import { render, staticRenderFns } from "./QuizState.vue?vue&type=template&id=4812bed2&scoped=true&"
import script from "./QuizState.vue?vue&type=script&lang=js&"
export * from "./QuizState.vue?vue&type=script&lang=js&"
import style0 from "./QuizState.vue?vue&type=style&index=0&id=4812bed2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4812bed2",
  null
  
)

export default component.exports